import { Elm } from "@/components/elm/SpaChoice.elm"
import { pushGa4Event } from "@/helpers/ga4_helper"
import { loadBackgroundImages } from "@/helpers/image_loader"
import { parameterize } from "@/helpers/parameterize"

declare global {
  interface Window {
    selectionData: {
      choice: string
      region: string
    }
    venueData: {
      options: Array<string>
      regions: Array<string>
    }
  }
}

const path = (region: string | null, choice: string | null): string =>
  parameterize(`/spa-choice${choice ? `/${choice}` : ""}${region ? `/${region}` : ""}`)

const packagesContainerElm = document.getElementById("elm-spa-choice-packages")

if (packagesContainerElm) {
  const app = Elm.SpaChoice.init({
    node: packagesContainerElm,
    flags: Object.assign(window.venueData, window.selectionData)
  })

  const { region, choice } = window.selectionData
  history.replaceState({ region, choice }, "", path(region, choice))
  loadBackgroundImages()

  app.ports.pushUrl.subscribe(([region, choice]: [string, string]) => {
    history.pushState({ region, choice }, "", path(region, choice))
    loadBackgroundImages()
  })

  app.ports.pushGa4Event.subscribe(pushGa4Event)

  window.addEventListener("popstate", (e: PopStateEvent): void => {
    app.ports.popState.send(
      Object.assign(window.venueData, {
        choice: e.state?.choice,
        region: e.state?.region
      })
    )
    window.requestAnimationFrame(() => loadBackgroundImages())
  })
}
